import { Component} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { BindWalletCallbackUsecase } from '../../core/usecase/fs-wallet-account/bind-wallet-callback-usecase';
import { Subject, takeUntil } from 'rxjs';
import { FlutterBridgeService } from '../../core/services/flutter-bridge/flutter-bridge.service';

@Component({
  selector: 'wallet-binding-callback',
  templateUrl: './wallet-binding-callback.component.html',
  styleUrls: ['./wallet-binding-callback.component.scss'],
})
export class WalletBindingCallbackComponent {
  wallet_id: string = '';
  accountId: string = '';
  authCode: string = '';
  partnerReferenceNo: string = '';
  status: "SUCCESS" | "FAILED" | ''  = '';
  isLoading = true;
  isBindingError = false;

  private readonly ngUnsubsribe$ = new Subject<void>();
  constructor(
    private readonly route: ActivatedRoute,
    private readonly bindWalletCallbackUsecase: BindWalletCallbackUsecase,
    private readonly messageService: MessageService,
    private readonly translateService: TranslateService,
    private readonly flutterBridgeService: FlutterBridgeService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.ngUnsubsribe$)).subscribe((params) => {
      this.wallet_id = params.get('id') || '';
    });
    if (this.wallet_id) {
      this.route.queryParams
      .subscribe(params => {
        if(params['authCode']) {
          this.authCode = params['authCode'];
          this.partnerReferenceNo = params['partnerReferenceNo'];
          this.status = params['status'];
          this.bindWalletCallback()
        }
      });
    }
  }

  bindWalletCallback() {
    this.isLoading = true;
    const data = {
      wallet_id: this.wallet_id,
      authCode: this.authCode,
      partnerReferenceNo: this.partnerReferenceNo,
      status: this.status,
    };
    this.bindWalletCallbackUsecase
      .execute(data)
      .pipe(takeUntil(this.ngUnsubsribe$))
      .subscribe({
      next: (res) => {
        // this.isLoading = false;
        this.flutterBridgeService.sendBindingSuccess(res.message);
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        console.log('error boyy');

        const error_detail =
          this.translateService.instant('messages.error');
        this.messageService.add({
          severity: 'error',
          detail: error_detail,
        });
      },
      });
  }
}
